import React, { Component } from "react";

import { connect } from "react-redux";
import { AppState } from "../../store";
import { withRouter } from "react-router";
import { HashLoader } from "react-spinners";
import { NavLink as Link } from "react-router-dom";
import { ClientsState } from "../../store/clients/types";
import { ScriptsState } from "../../store/scripts/types";

import "./accounts.css";
import { ReactComponent as CopyToClipboard } from '../../icons/copy_clipboard.svg';
import { Alert, Snackbar } from "@mui/material";



interface ScriptDetailsSectionInterfaceProps {
  clients: ClientsState;
  emptyClient: Function;
  updateClientField: Function;
  updateScriptField: Function;
  scripts: ScriptsState;
  saveClient: Function;
  saveScript: Function;
}

type MyState = {
  copyToClipboardDone: boolean;
  isEdit: boolean;
};

class ScriptDetailsSectionSection extends Component<ScriptDetailsSectionInterfaceProps> {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSourceChange = this.handleSourceChange.bind(this);
    this.editScript = this.editScript.bind(this);
  }

  state: MyState = {
    // optional second annotation for better type inference
    copyToClipboardDone: false,
    isEdit: false
  };

  public componentDidMount(): void { }

  private getScript(): string {
    return ``;
  }

  public edit(id): void { }

  private handleChange(field: string, value: any): void {
    console.log(field);
    console.log(value);
    if (field === "frequency" && value > 1000) {
      value = 1000;
    }
    this.props.updateScriptField(field, value);
  }

  private handleSourceChange(field: string, value: any, source: any): void {
    console.log(field);
    console.log(source);
    var val;
    const srcs = this.props.scripts.editedScript.sources.split(',');
    console.log(srcs);

    const index = srcs.indexOf(source);
      if (index > -1) {
        console.log(srcs);
        srcs.splice(index, 1);
        
      } else {
        console.log(srcs);
        srcs.push(source);
        
      }
    
    val = srcs.join(',');
    console.log(val);
    this.props.updateScriptField(field, val);
  }

  public editScript = (event: boolean, type?: any) => {
    this.setState({ isEdit: event });
    if (event == false && type == "save") {
      this.props.saveScript(this.props.scripts.editedScript);
    }
  };

  public render(): JSX.Element {
    console.log(this);
    const { scripts } = this.props;
    const { isEdit } = this.state;
    const sources = this.props.scripts.editedScript.sources.split(',');

    return (
      <div className="general_detail_section">
        <div className="section_title">
          <h2>Script Details</h2>
          {isEdit ? (
            <div>
              <button
                className="button secondary mr-3"
                onClick={() => this.editScript(false)}
              >
                Cancel
              </button>
              <button
                className="button accent"
                onClick={() => {
                  this.editScript(false, "save");
                }}
              >
                Save
              </button>
            </div>
          ) : (
            <button
              className="button accent"
              onClick={() => this.editScript(true)}
            >
              Edit
            </button>
          )}
        </div>

        <div className="form_details">
          <div className="form_title">Client ID</div>
          <div className="flexBox">
            <div id="w100">
              <label className="field_label fw-600">{this.props.clients.editedClient.id}</label>
            </div>
          </div>
        </div>

        <div className="form_details">
          <div className="form_title">Extra Credits</div>
          <div>Per Rebill</div>
          <label className="field_label"></label>
          <div>
            <input
              required
              type="text"
              // value={this.props.clients.editedClient.frequency || 1}
              value={this.props.scripts.editedScript.extraCredsPerBill || 0}
              onChange={(event) =>
                this.handleChange("extraCredsPerBill", parseInt(event.target.value))
              }
              disabled={!isEdit}
            />
          </div>
        </div>

        <div className="form_details">
          <div className="form_title">Frequency</div>
          <div>1000 days max</div>
          <label className="field_label"></label>
          <div>
            <input
              required
              type="text"
              // value={this.props.clients.editedClient.frequency || 1}
              value={this.props.scripts.editedScript.uniquePerDay || ''}
              onChange={(event) =>
                this.handleChange("uniquePerDay", parseInt(event.target.value))
              }
              disabled={!isEdit}
            />
          </div>
        </div>

        <div className="form_details">
          <div className="form_title">Sources</div>
          <div>
            {/* Assume we have an array of available checkbox values */}
            {["124", "126", "127", "129", "130"].map((sourceValue) => (
              <div key={sourceValue}>
                <input
                  type="checkbox"
                  value={sourceValue}
                  checked={sources.includes(sourceValue)}
                  onChange={(event) => this.handleSourceChange("sources", event, sourceValue)}
                  disabled={!isEdit}
                />
                <label>{sourceValue}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="form_details">
          <div className="form_title">Source ID Value</div>
          <div>Insert Value if SourceID 30 is selected</div>
          <label className="field_label"></label>
          <div>
            <input
              type="text"
              value={this.props.scripts.editedScript.retentionId || ''}
              onChange={(event) =>
                this.handleChange("retentionId", event.target.value)
              }
              disabled={!isEdit}
            />
          </div>
        </div>

        <div className="form_details">
        <div className="form_title">Email Cleaner</div>
      
        <div>
          <input
            type="checkbox"
            checked={Number(this.props.scripts.editedScript.emailCleaner) === 1}
            onChange={(e) =>
              this.handleChange("emailCleaner", e.target.checked ? 1 : 0)
            }
            disabled={!isEdit}
          />
        </div>
      </div>

        <div className="form_details">
        <div className="form_title">Activity Checker</div>
      
        <div>
          <input
            type="checkbox"
            checked={Number(this.props.scripts.editedScript.activityChecker) === 1}
            onChange={(e) =>
              this.handleChange("activityChecker", e.target.checked ? 1 : 0)
            }
            disabled={!isEdit}
          />
        </div>
      </div>


        <div className="form_details">
          <div className="form_title">Activity Checker Lookback</div>
          <label className="field_label"></label>
          <div>
            <input
              required
              type="text"
              value={this.props.scripts.editedScript.activityCheckerLookback || 45}
              onChange={(event) =>
                this.handleChange("activityCheckerLookback", parseInt(event.target.value))
              }
              disabled={!isEdit}
            />
          </div>
        </div>



        <div className="form_details">
          <div className="form_title">Script</div>

          <div className="flexBox">
            <div id="w100">
              <label className="field_label fw-600">
                Tag <CopyToClipboard onClick={() => { navigator.clipboard.writeText(this.getScript()); this.setState({ copyToClipboardDone: true }) }} className="clipboard_icon" />
              </label>
              <div>
                <div>
                  <textarea
                    value={this.getScript()}
                    onChange={(event) =>
                      this.handleChange("code", event.target.value)
                    }
                    disabled
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={this.state.copyToClipboardDone} autoHideDuration={6000} onClose={() => this.setState({ copyToClipboardDone: false })}>
          <Alert onClose={() => this.setState({ copyToClipboardDone: false })} severity="info" sx={{ width: '100%' }}>
            Copied to clipboard
          </Alert>
        </Snackbar>
      </div>
    );
  }
}

export default ScriptDetailsSectionSection;
